import { InformationBarActions } from './informationBar.actions';
import { Action } from '@ngrx/store';

export const initialAppState: IInformationBarState = {customPropertiesInformationBar: {}};

export function informationBarReducer (state: IInformationBarState = initialAppState, action: any) {
   switch (action.type) {
      case InformationBarActions.ADD:
        return {...state, customPropertiesInformationBar: action.payload};
      default:
        return state;
    }
};
